export const GET_VISITOR_PERMITLIST = "visitor-permit/GET_VISITOR_PERMITLIST";
export const SET_VISITOR_PERMITLIST = "visitor-permit/SET_VISITOR_PERMITLIST";

export const CREATE_VISITOR_PERMIT = "visitor-permit/CREATE_VISITOR_PERMIT";
export const SET_VISITOR_PERMIT = "visitor-permit/SET_VISITOR_PERMIT";

export const GET_PDF_VISITOR_PERMIT = "visitor-permit/GET_PDF_VISITOR_PERMIT";
export const SET_PDF_VISITOR_PERMIT = "visitor-permit/SET_PDF_VISITOR_PERMIT";

export const GET_CARD_TYPE_VISITOR_PERMIT =
  "visitor-permit/GET_CARD_TYPE_VISITOR_PERMIT";
export const SET_CARD_TYPE_VISITOR_PERMIT =
  "visitor-permit/SET_CARD_TYPE_VISITOR_PERMIT";

export const OPEN_VISITOR_PERMIT_ORDER_SUCCESS_MODAL =
  "visitor-permit/OPEN_VISITOR_PERMIT_ORDER_SUCCESS_MODAL";
export const CLOSE_VISITOR_PERMIT_ORDER_SUCCESS_MODAL =
  "visitor-permit/CLOSE_VISITOR_PERMIT_ORDER_SUCCESS_MODAL";

export const setVisitorPermitListAction = (data) => {
  return {
    type: SET_VISITOR_PERMITLIST,
    payload: data,
  };
};

export const getVisitorPermitListAction = (data) => {
  return {
    type: GET_VISITOR_PERMITLIST,
    payload: data,
  };
};

export const createVisitorPermitAction = (data) => {
  return {
    type: CREATE_VISITOR_PERMIT,
    payload: data,
  };
};

export const setVisitorPermit = (data) => {
  return {
    type: SET_VISITOR_PERMIT,
    payload: data,
  };
};

export const getPDFVisitorPermit = (data) => {
  return {
    type: GET_PDF_VISITOR_PERMIT,
    payload: data,
  };
};

export const setPDFvisitorPermit = (data) => {
  return {
    type: SET_PDF_VISITOR_PERMIT,
    payload: data,
  };
};

export const getCardTypeVisitorPermit = (data) => {
  return {
    type: GET_CARD_TYPE_VISITOR_PERMIT,
    payload: data,
  };
};

export const setCardTypeVisitorPermit = (data) => {
  return {
    type: SET_CARD_TYPE_VISITOR_PERMIT,
    payload: data,
  };
};

export const openVisitorPermitOrderSuccessModal = () => {
  return {
    type: OPEN_VISITOR_PERMIT_ORDER_SUCCESS_MODAL,
    payload: true,
  };
};

export const CloseVisitorPermitOrderSuccessModal = () => {
  return {
    type: CLOSE_VISITOR_PERMIT_ORDER_SUCCESS_MODAL,
    payload: false,
  };
};
